import { render, staticRenderFns } from "./TBtnLink.vue?vue&type=template&id=44d4dbf5"
import script from "./TBtnLink.vue?vue&type=script&lang=js"
export * from "./TBtnLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports